<template>
    <div class="remote-select">
        <el-select
                v-model="query"
                :multiple="multiple"
                filterable
                clearable
                remote
                placeholder="请输入关键词"
                :remote-method="remoteMethod"
                :loading="loading">
            <el-option
                    v-for="item in options"
                    :key="item[optionValue]"
                    :label="item[optionLabel]"
                    :value="item[optionValue]">
            </el-option>
        </el-select>
    </div>
</template>
<script type="text/javascript">
    import axios from 'axios'

    export default {
        props: {
            url: {
                type: String,
                'default': '/schoolSearch.api'
            },
            multiple: {
                type: Boolean,
                'default': false
            },
            clearable: {
                type: Boolean,
                'default': true
            },
            name: {
                type: String,
                'default': 'name'
            },
            value: {
                type: String
            },
            optionLabel: {
                type: String,
                'default': 'text'
            },
            optionValue: {
                type: String,
                'default': 'value'
            }
        },

        data () {
            return {
                options: [],
                query: this.value || '',
                loading: false
            }
        },
        watch: {
            query: function (value) {
                this.$emit('input', value)
            }
        },
        methods: {
            remoteMethod (query) {
                let params = {
                    'X-loadingOff': true
                }
                params[this.name] = query
                if (query !== '') {
                    this.loading = true
                    axios.get(this.url, {
                        params: params
                    }).then((res) => {
                        this.loading = false
                        this.options = res.result.list
                    })
                } else {
                    this.options = []
                }
            }
        }
    }
</script>
<style type="text/css" lang="scss" scoped>
    .remote-select {

    }
</style>


// WEBPACK FOOTER //
// remoteSelect.vue?699abf88